import React, { useContext, useEffect, useState } from "react";
import { Icon } from "components";
import styles from "styles/sidebar.module.scss";
import {
  faChartLine,
  faBullhorn,
  faCog,
  faCartPlus,
  faQuestionCircle,
  faThumbtack,
  faLightbulb,
  faUsers,
  faHandshake,
} from "@fortawesome/fontawesome-pro-solid";
import { Reviewing } from "components";
import UserContext from "context/UserContext";
import ShopContext from "context/ShopContext";
import useReactRouter from "use-react-router";
import SidebarContext from "context/SidebarContext";
import {
  USER_SHIELD_ICON,
  SACK_DOLLAR_ICON,
  COMMENT_DOLLAR,
} from "lib/globals";
import Logo from "svgs/logo_v2.png";
import { LIST_SHOP_CAMPAIGNS } from "Queries";
import { useQuery } from "@apollo/react-hooks";
import classNames from "lib/classNames";

const SideBar = () => {
  const { collapsed, setCollapsed } = useContext(SidebarContext);
  const { history, location } = useReactRouter();

  const [campaignActive, setCampaignActive] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [designActive, setDesignActive] = useState(false);
  const [completedTasks, setCompletedTasks] = useState(0);

  const user = useContext(UserContext);
  const shopContext = useContext(ShopContext);
  const {
    AppLocalStorage,
    setup: { cartActive, cartLoading },
  } = shopContext;
  let { data } = useQuery(LIST_SHOP_CAMPAIGNS, {
    variables: {
      userId: user.attributes.sub,
    },
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    const app_first_turn_on = AppLocalStorage.getItem("first_cart_turn_on");
    setDesignActive(app_first_turn_on);
  }, [AppLocalStorage]);

  useEffect(() => {
    if (data) {
      if (data.campaigns?.list?.length) {
        setCampaignActive(
          !!data.campaigns.list.find((campaign) => campaign.active)
        );
      }
      setDataLoading(false);
    }
  }, [data]);

  useEffect(() => {
    if (!dataLoading && !cartLoading) {
      setCompletedTasks(+cartActive + +designActive + +campaignActive);
    }
  }, [cartActive, designActive, campaignActive, cartLoading, dataLoading]);

  return (
    <div className={styles.sidebar} collapsed={collapsed ? 1 : 0}>
      <div className={styles.logo}>
        <img src={Logo} />
      </div>
      <div className={styles.menu}>
        <div
          className={styles.menu_setup}
          data-active={location.pathname === "/"}
          data-completed={completedTasks === 3}
          pathto={"/"}
          onClick={() => {
            if (location.pathname !== "/") history.push("/" + location.search);
          }}
        >
          <div
            className={`${styles.div} ${classNames(
              "flex flex-col items-start"
            )}`}
          >
            <span className={styles.text}>Getting started</span>
            <div
              className={classNames(
                "flex flex-row items-center justify-start w-full"
              )}
              style={{
                marginTop: 3,
              }}
            >
              <div
                className={classNames(
                  "flex w-3/4 h-3 rounded-md relative overflow-hidden mix-blend-darken bg-white items-start"
                )}
                style={{
                  background: "rgba(93, 120, 240, 0.2)",
                }}
              >
                <div
                  className={classNames(
                    "block transition-width absolute inset-0 duration-500 ease-out z-10 items-start rounded-md"
                  )}
                  style={{
                    background: completedTasks < 3 ? "#5D78F0" : "#48bb78",
                    width: `${
                      completedTasks ? (completedTasks * 100) / 3 : 10
                    }%`,
                  }}
                ></div>
              </div>
              <span
                className={`${styles.counter} ${classNames(
                  "text-gray-600 font-bold ml-2"
                )}`}
              >
                {completedTasks}/3
              </span>
            </div>
          </div>
        </div>
        <MenuItem
          pathto="/dashboard"
          activeRoutes={["/dashboard"]}
          icon={faChartLine}
        >
          Dashboard
        </MenuItem>
        <MenuItem pathto="/settings" activeRoutes={["/settings"]} icon={faCog}>
          Cart Setup
        </MenuItem>
        <MenuItem
          pathto="/campaigns"
          activeRoutes={["/campaigns"]}
          icon={faBullhorn}
        >
          Upsell Campaigns
        </MenuItem>
        <MenuItem pathto="/sticky" activeRoutes={["/sticky"]} icon={faCartPlus}>
          Sticky cart
        </MenuItem>
        <div className={styles.spacer}></div>
        {data?.campaigns?.list?.length ? (
          <MenuItem
            onClick={() => {
              window.open(
                "https://monsterapps.crisp.help/en/article/redeemly-cashback-loyalty-store-credit-special-offer-apooev/"
              );
            }}
            badge="NEW APP"
            newApp
          >
            CashBack Loyalty App
            <br />
            (BONUS FREE OFFER)
          </MenuItem>
        ) : (
          <></>
        )}
        <MenuItem
          pathto="/integrations"
          activeRoutes={["/integrations"]}
          icon={faHandshake}
        >
          Integrations
        </MenuItem>
        <MenuItem
          icon={COMMENT_DOLLAR}
          onClick={() => {
            window.open(
              "https://platform.shoffi.app/signup/affiliate?app=Il_7GsC6qzi"
            );
          }}
        >
          Referral Program
        </MenuItem>
        {/* <MenuItem onClick={() => {window.open("https://monsterapps.shop/partner-program/")}}>
					Affiliate Signup
				</MenuItem> */}
        <MenuItem
          icon={faUsers}
          onClick={() => {
            window.open("https://www.facebook.com/groups/ecom.monsterapps");
          }}
        >
          Facebook Group
        </MenuItem>
        <MenuItem
          icon={faLightbulb}
          onClick={() => {
            window.open(
              "https://monsterupsells.feedbear.com/boards/feature-requests"
            );
          }}
        >
          Feature Suggestion
        </MenuItem>
        <MenuItem pathto="/plan" icon={SACK_DOLLAR_ICON}>
          Your Plan
        </MenuItem>
        <MenuItem
          icon={faQuestionCircle}
          onClick={() => {
            window.open(
              "https://monsterapps.crisp.help/en/category/monsterupsells-48n04z"
            );
          }}
        >
          Faq
        </MenuItem>
        <MenuItem
          icon={USER_SHIELD_ICON}
          onClick={() => {
            window.open(
              "https://monsterapps.crisp.help/en/article/privacy-policy-monsterupsells-76n8in"
            );
          }}
        >
          Privacy Policy
        </MenuItem>
      </div>
      <div className={styles.attach} active={collapsed ? 0 : 1}>
        <Icon
          icon={faThumbtack}
          size="xs"
          onClick={() => setCollapsed(!collapsed)}
        />
      </div>
      {/* <div className={styles.widget}>
        <Reviewing {...{ user, shopContext }} />
      </div> */}
    </div>
  );
};

const MenuItem = ({
  pathto,
  activeRoutes = false,
  children,
  icon,
  onClick,
  badge,
  newApp,
}) => {
  const { history, location } = useReactRouter();
  const active = (activeRoutes || [pathto]).includes(location.pathname);
  return (
    <div
      className={`${styles.menu_item}${newApp ? " " + styles.new_app : ""}`}
      data-active={active}
      pathto={pathto}
      onClick={() => {
        if (onClick) onClick();
        else if (!active) history.push(pathto + location.search);
      }}
    >
      <div>
        {icon && <Icon icon={icon} size="lg" />}
        <span className={styles.text}>{children}</span>
      </div>
      {badge && <SideBarBadge>{badge}</SideBarBadge>}
    </div>
  );
};

export const SideBarBadge = ({ children, style, className = "" }) => (
  <div className={`${styles.badge} ${className}`} style={style}>
    {children}
  </div>
);

export default SideBar;
